<template>

    <b-modal id="my-quizzes-delete-elements-modal" class="modal-delete-elements" size="sm" centered hide-header hide-footer>

        <div class="close-btn" @click="close"></div>

        <div class="px-1 py-3">
            <p class="mb-3">{{ t.__('Czy napewno chcesz to usunąć?') }}</p>
            <div class="row">
                <div class="col-9">
                    <div class="row">
                        <div class="col-6">
                            <b-button variant="secondary" block @click="close" :disabled="processing">{{ t.__('Jeszcze nie') }}</b-button>
                        </div>
                        <div class="col-6">
                            <b-button variant="danger" block @click="deleteElements" :disabled="processing" v-text="processing ? t.__('Usuwam...') : t.__('Usuń')"></b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </b-modal>

</template>

<script>

export default {

    name: 'MyQuizzesDeleteElementsModal',

    data() {
        return {
            eventHub: window.eventHub,
            processing: false
        }
    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-delete-elements', () => {
            this.$bvModal.show('my-quizzes-delete-elements-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-delete-elements-modal') {
                this.processing = false;
            }
        });

        this.eventHub.$on('my-quizzes-delete-elements-complete', () => {
            this.close();
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-delete-elements-modal');
        },

        deleteElements() {
            this.processing = true;
            this.eventHub.$emit('my-quizzes-delete-elements-start');
        }

    }

}

</script>

<style scoped>

</style>
